import { render, staticRenderFns } from "./AdditionalsCharges.vue?vue&type=template&id=5b8501b4&"
import script from "./AdditionalsCharges.vue?vue&type=script&lang=js&"
export * from "./AdditionalsCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports